import { createSelector } from 'reselect';

export const selectLawyerAssignmentsState = (state: any) =>
  state.get('lawyerAssignmentsState');

export const makeSelectLawyerAssignedClaims = () =>
  createSelector(selectLawyerAssignmentsState, lawyerAssignmentsState => {
    if (
      lawyerAssignmentsState &&
      lawyerAssignmentsState.get('assignedClaims')
    ) {
      return lawyerAssignmentsState.get('assignedClaims').toJS();
    }
    return [];
  });

export const makeSelectLegalProceedingsSteps = () =>
  createSelector(selectLawyerAssignmentsState, lawyerAssignmentsState => {
    if (lawyerAssignmentsState && lawyerAssignmentsState.get('steps')) {
      return lawyerAssignmentsState.get('steps').toJS();
    }
    return [];
  });

export const makeSelectLawyerAssignedClaimsCount = () =>
  createSelector(selectLawyerAssignmentsState, lawyerAssignmentsState => {
    if (
      lawyerAssignmentsState &&
      lawyerAssignmentsState.get('assignedClaimsCount')
    ) {
      return lawyerAssignmentsState.get('assignedClaimsCount');
    }
    return 0;
  });
